(function($, App, Utils, Components) {
  'use strict';

  var logger = new Logger('Menu');

  Components.create('Menu', {
    
    Selectors: {
      Main: 'nav.main-nav',
      HasSubMenu: '.has-submenu'
    },
    
    open: function(target, bodyClass, backdrop) {
      let $storeLocator = $('.js-store-locator-main');
      logger.l('opening...');
      $(target).addClass('open');
      App.Html.addClass(bodyClass);

      if (backdrop && $(backdrop).length != 0) {
        $(backdrop).addClass('in');
      } else {
        App.Body.append(`<div class="${backdrop.split('.').join('')}"></div>`);
        $(backdrop).addClass('in');
      }

      if ($storeLocator && $storeLocator.hasClass('list-in')) {
        $('[data-om-toggle="list-in"]').trigger('click');
      }
      App.Window.trigger('menu:opened');
    },

    close: function(target, bodyClass, backdrop) {
      $(target + '.open').each(function(i, e) {
        if ($(target + '.open input:focus').length != 0) {
          logger.l('Skip closing, input in focus.');
          return;
        }

        logger.l('closing...');
        $(e)
          .removeClass('open')
          .addClass('animating');
        App.Html.addClass('animating').removeClass(bodyClass);

        // If you change this timing please
        // change it in the CSS (default/_commons.scss) accordingly
        setTimeout(function() {
          $(e).removeClass('animating');
          App.Html.removeClass('animating');
        }, 200);
      });

      if (backdrop && $(backdrop).length != 0) {
        $(backdrop).removeClass('in');
      } else {
        $(backdrop).removeClass('in');
        App.Body.remove(backdrop);
      }

      App.Window.trigger('menu:closed');
    },

    closeAll: function() {
      $('*[data-menu]').each(function(i, e) {
        var self = $(this),
          bodyClass = self.data('menuHtmlClass'),
          target = self.data('menu'),
          backdrop = self.data('backdrop');

        Components.Menu.close(target, bodyClass, backdrop);
      });
    },

    bindEvents: function() {
      $('*[data-menu]').on('click', function() {
        var self = $(this),
          bodyClass = self.data('menuHtmlClass'),
          target = self.data('menu'),
          backdrop = self.data('backdrop');

        if (App.Html.hasClass(bodyClass)) {
          Components.Menu.close(target, bodyClass, backdrop);
        } else {
          Components.Menu.open(target, bodyClass, backdrop);
        }
      });

      $(window).on('resize', function() {
        // Resize event is triggered in mobile device when scrolling
        // and the UI is shrinked or maximized.
        // In this very case we don't want to close the menus.
        if (Utils.Browsers.is('ios') || Utils.Browsers.is('android')) {
          return;
        }

        Components.Menu.closeAll();
      });
    },

    init: function() {
      Components.Menu.bindEvents();
    }
  });
})(jQuery, window.App, window.App.Utils, window.App.Components);
